import type {Dispatch, SetStateAction} from "react";
import {useCallback, useMemo, useState} from "react";
import type {RowSelectionState} from "@tanstack/react-table";

export interface IRowSelectionState {
    onRowSelectionChange: Dispatch<SetStateAction<RowSelectionState>>;
    onRowSelectionClear: () => void;
    rowSelection: RowSelectionState;
    rowSelectionCount: number;
    selectedIds: string[];
}

export const useTableRowSelectionState = (rowSelectionInitialState?: RowSelectionState): IRowSelectionState => {
    const [rowSelection, onRowSelectionChange] = useState<RowSelectionState>(rowSelectionInitialState || {});

    const rowSelectionCount = useMemo(() => {
        if (!rowSelection) {
            return 0;
        }
        return Object.entries(rowSelection).filter(([_key, value]) => value).length;
    }, [rowSelection]);

    const selectedIds = useMemo(() => {
        if (!rowSelection) {
            return [];
        }
        return Object.entries(rowSelection)
            .filter(([_key, value]) => value)
            .map(([key]) => key);
    }, [rowSelection]);

    const onRowSelectionClear = useCallback(() => {
        onRowSelectionChange({});
    }, [onRowSelectionChange]);

    return {
        selectedIds,
        rowSelection,
        rowSelectionCount,
        onRowSelectionClear,
        onRowSelectionChange
    };
};
import type {Dispatch, SetStateAction} from "react";
import {useCallback, useMemo, useState} from "react";
import type {RowSelectionState} from "@tanstack/react-table";

export interface IRowSelectionState {
    onRowSelectionChange: Dispatch<SetStateAction<RowSelectionState>>;
    onRowSelectionClear: () => void;
    rowSelection: RowSelectionState;
    rowSelectionCount: number;
    selectedIds: string[];
}

export const useTableRowSelectionState = (rowSelectionInitialState?: RowSelectionState): IRowSelectionState => {
    const [rowSelection, onRowSelectionChange] = useState<RowSelectionState>(rowSelectionInitialState || {});

    const rowSelectionCount = useMemo(() => {
        if (!rowSelection) {
            return 0;
        }
        return Object.entries(rowSelection).filter(([_key, value]) => value).length;
    }, [rowSelection]);

    const selectedIds = useMemo(() => {
        if (!rowSelection) {
            return [];
        }
        return Object.entries(rowSelection)
            .filter(([_key, value]) => value)
            .map(([key]) => key);
    }, [rowSelection]);

    const onRowSelectionClear = useCallback(() => {
        onRowSelectionChange({});
    }, [onRowSelectionChange]);

    return {
        selectedIds,
        rowSelection,
        rowSelectionCount,
        onRowSelectionClear,
        onRowSelectionChange
    };
};
